import type { Workflow } from "@stockline/shared/types/ai/workflow"
import type { OfflineResourceConfig } from "../../../types"
import { WORKFLOW_TABLE } from "./db"

export const workflowConfig: OfflineResourceConfig<Workflow> = {
  name: "workflows",
  endpoints: {
    full: "/api/v2/workflows",
    delta: "/api/v2/workflows/changes",
    push: "/api/v2/workflows/changes",
  },
  tableName: WORKFLOW_TABLE,
  primaryKey: "id",
  indexes: {
    companyId: "companyId",
    scope: "scope",
    isActive: "isActive",
  },
  applyChange: (local, patch) => ({ ...local, ...patch }),
}
